import { Tag } from "primereact/tag";
import { deliveryStatuses } from "../helpers/deliveryStatuses";

type DeliveryStatusTagProps = {
  deliveryStatus: string;
};

const severityMap: Record<
  string,
  "secondary" | "info" | "success" | "warning" | "danger" | undefined
> = {
  DRAFT: "secondary",
  NEW: "secondary",
  APPROACHING_ORIGIN: "info",
  APPROACHING_DESTINATION: "info",
  IN_DESTINATION: "info",
  CONFIRMED: "success",
  CANCELLED: "danger",
};

export default function DeliveryStatusTag({
  deliveryStatus,
}: DeliveryStatusTagProps) {
  const foundStatus = deliveryStatuses.find(
    (status) => status.id === deliveryStatus,
  );

  const label = foundStatus?.name || "Brak statusu";
  const severity = severityMap[deliveryStatus];

  return (
    <>
      <Tag
        value={label}
        severity={severity}
        className={`status-tag status-${deliveryStatus.toLowerCase()}`}
      />
    </>
  );
}
